module.exports = function() {
  return new Worker("/" + "parcel-html-transpiler.e0273d5a.worker.js");
};